import React from 'react';
import ModalOverlay from './ModalOverlay';

interface DeleteConfirmModalProps {
  active: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  active,
  onClose,
  onConfirm,
  message = 'Are you sure you want to delete this record? This action cannot be undone.',
}) => {
  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-sm">
        <div className="modal-header">
          <h2>Confirm Delete</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <p style={{ padding: '0 1.5rem' }}>{message}</p>
        <div className="form-actions">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default DeleteConfirmModal;
